import { fetcher } from "helpers/fetcher";

import { TUpdateCorpSequenceReq, TUpdateCorpSequenceRes } from "./types";
import { API_HEADER } from "../constants";
import { ENDPOINT } from "../endpoint";

export const updateCorporationSequence = async (
  params: TUpdateCorpSequenceReq
) => {
  return await fetcher<
    TUpdateCorpSequenceRes,
    { corporationSequence: string[] },
    TUpdateCorpSequenceReq
  >(ENDPOINT.USER.UPDATE_CORPORATION_SEQUENCE, {
    params: {
      idMember: params.idMember,
    },
    data: {
      corporationSequence: params.corporationSequence,
    },
    headers: {
      [API_HEADER.VERSION]: ENDPOINT.USER.UPDATE_CORPORATION_SEQUENCE.version,
    },
  });
};

export const mutationUpdateCorporationSequence = async (
  params: TUpdateCorpSequenceReq
) => {
  return (await updateCorporationSequence(params)).data;
};

mutationUpdateCorporationSequence._key = (params: TUpdateCorpSequenceReq) => [
  ENDPOINT.USER.UPDATE_CORPORATION_SEQUENCE.url,
  params,
];
